import { graphql } from "@/graphql/codegen"
import "./fragments"

graphql(`
  query GetGlTransaction($input: GlTransactionGetInput!) {
    glTransaction {
      get(input: $input) {
        ... on GlTransactionGetSuccess {
          glTransaction {
            ...GlTransactionBaseFields
            glTransactionRows {
              ...GlTransactionRowFields
            }
          }
        }
        ... on GlTransactionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
